/*
 * File: ApptDayBottomNavigation.js
 * Project: mp-mobile-app
 * *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Implements and styles the bottom navigation bar in the Schedule
 */
import React from "react";
import { observer } from "mobx-react";
import { Paper, Button, withStyles } from "@material-ui/core";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import ui from "../store/UIStore";
import ApptStore from "services/appointments/store/DataStore";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";

const styles = theme => ({
  paper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.primary.main,
    height: 70,
    zIndex: 1,
    flex: "0 0 auto"
  },
  navButton: {
    color: theme.palette.common.white
  }
});

class ApptDayBottomNavigation extends React.Component {
  static contextType = StoreContext;

  get uiStore() {
    return this.context.getStore(ui);
  }

  handleDayNav(name) {
    let data = this.context.getStore(ApptStore);
    let today = new Date();
    if (name === "today") {
      this.uiStore.setDate(today);
    } else if (name === "prev") {
      this.uiStore.prev();
    } else {
      this.uiStore.next();
    }
    data.reloadAppts(this.context);
  }

  render() {
    const { classes } = this.props;
    const { prevDateString, nextDateString } = this.uiStore;
    return (
      <Paper square elevation={0} className={classes.paper}>
        <Button
          className={classes.navButton}
          disableRipple
          onClick={() => this.handleDayNav("prev")}
        >
          <KeyboardArrowLeft />
          {prevDateString}
        </Button>
        <Button
          className={classes.navButton}
          disableRipple
          onClick={() => this.handleDayNav("today")}
        >
          Today
        </Button>
        <Button
          className={classes.navButton}
          disableRipple
          onClick={() => this.handleDayNav("next")}
        >
          {nextDateString}
          <KeyboardArrowRight />
        </Button>
      </Paper>
    );
  }
}

ApptDayBottomNavigation.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(ApptDayBottomNavigation));
